import { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

export const PercentageChange: FC<{changePercentage?: number | null}> = ({changePercentage}) => {
    const getChangeDescription = (): string => {
        if(changePercentage === undefined || changePercentage === null) {
            return "";
        }
        if(changePercentage === 0) {
            return "No change from previous period";
        }
        return `${Math.abs(changePercentage)}% VS previous period`;
    };

    const renderArrow = () => {
        if(changePercentage && changePercentage > 0) {
            return <FontAwesomeIcon icon='fa-regular fa-circle-caret-up' className="text-emerald-400" />
        } else if (changePercentage && changePercentage < 0) {
            return <FontAwesomeIcon icon='fa-regular fa-circle-caret-down' className="text-base-destructive" />
        }
        return null;
    };

    const changeDescription = getChangeDescription();

    return (
        <div className="flex items-center mb-1 gap-2 py-2">
          {renderArrow()}
          <span className="text-base-mutedForeground text-p-s min-h-5 inline-block">{changeDescription}</span>
        </div>
    );
}